'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _getHeight2 = require('./getHeight');

var _getHeight3 = _interopRequireDefault(_getHeight2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Textarea = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Textarea, _React$Component);

  function Textarea() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Textarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = { height: 41 }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Textarea, [{
    key: 'autoResize',
    value: function autoResize(event) {
      if (!this.props.autoResize) return;

      var _getHeight = (0, _getHeight3.default)(this.refs.input),
          height = _getHeight.height;

      if (this.state.height !== height) {
        this.setState({ height: height });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      this.props.onChange(event.target.value);
      this.autoResize(event);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'os-input-container' },
          _react2.default.createElement('textarea', (0, _extends3.default)({
            ref: 'input',
            className: 'os-input-text',
            rows: 1,
            style: { height: this.state.height },
            value: this.props.value,
            placeholder: this.props.placeholder,
            onChange: this.onChange
          }, this.props.passProps))
        ),
        _react2.default.createElement(
          'div',
          { className: 'os-input-error' },
          this.props.errorMessage
        )
      );
    }
  }]);
  return Textarea;
}(_react2.default.Component), _class2.propTypes = {
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.string,
  fieldType: _propTypes2.default.string,
  passProps: _propTypes2.default.object,
  placeholder: _propTypes2.default.node,
  errorMessage: _propTypes2.default.node,
  autoResize: _propTypes2.default.bool
}, _class2.defaultProps = {
  autoResize: true
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'autoResize', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'autoResize'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onChange'), _class.prototype)), _class);
exports.default = Textarea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/fields/Textarea/index.js
// module id = 433
// module chunks = 0